import RNEventSource from 'react-native-event-source';
import { EventSourcePolyfill } from 'event-source-polyfill';

export enum SsePlatforms {
  WEB,
  MOBILE
}

export enum SseListeners {
  SLOTS = 'scheduling_slots'
}

export interface SseConnection {
  eventSource: RNEventSource | EventSourcePolyfill | null;
}
